import React from "react";
import { DEFAULT_LANGUAGE, I18nProvider } from "./i18n";

/**
 * Shared `wrapPageElement` used by both gatsby-browser.js and gatsby-ssr.js so
 * the language context is identical during SSR and hydration.
 *
 * This is `wrapPageElement`, not `wrapRootElement`, because the language comes
 * from `pageContext` - which the root wrapper never sees. Pages Gatsby created
 * without a language (the unlocalized `/docs/*` routes) fall back to English,
 * and the provider swaps in the reader's stored preference there after mount.
 */
export const wrapPageElement = ({ element, props }) => {
  const language = props?.pageContext?.language || DEFAULT_LANGUAGE;
  return (
    <I18nProvider language={language}>
      {element}
    </I18nProvider>
  );
};
